import styled from 'styled-components';

export const ContainerAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  user-select: none;
  padding-top: 64px;
  .username {
    width: 196px;
    height: 42px;
    margin: 16px 42px 33px;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.31;
    letter-spacing: normal;
    text-align: center;
    color: #3a3a3a;
    text-transform: capitalize;
  }
  @media (min-width: 740px) {
    flex-direction: row;
    padding: 0;
    .username {
      margin: 0;
      margin-left: 25px;
      height: auto;
      width: auto;
    }
  }
`;
